import helpers from 'helpers'
import * as yup from 'yup'

const profileSchema = yup
  .number()
  .required('Selecione um perfil')
  .typeError('Selecione um perfil')

const schemaUser = (userClient, isEdit, profileResponsible) =>
  yup.object().shape({
    name: yup.string().trim().required(),
    email: yup.string().email().required(),
    ...((!userClient || (userClient && !isEdit)) && {
      profileId: profileSchema,
    }),
    ...(userClient &&
      !isEdit && {
        companyId: yup.object().required('Selecione uma empresa').nullable(),
        profileId: profileSchema,
        linkType: yup.string().required(),
      },
    profileResponsible && {
      phone: yup
        .string()
        .required()
        .test('is-valid-phone', 'Número de telefone inválido', (value) => {
          return helpers.validates.phone.schema({ value, required: true })
        }),
    }),
    ...(!userClient && {
      phone: yup
        .string()
        .nullable()
        .test('is-valid-phone', 'Número de telefone inválido', (value) => {
          return helpers.validates.phone.schema({ value })
        }),
    }),

    company: yup.object().when('linkType', {
      is: (linkType) => linkType && linkType === 'userCompany',
      then: yup.object().required().typeError('Preencha esse campo'),
      otherwise: yup.object().notRequired(),
    }),

    organization: yup.object().when('linkType', {
      is: (linkType) => linkType && linkType === 'organizationUser',
      then: yup.object().required().typeError('Preencha esse campo'),
      otherwise: yup.object().notRequired(),
    }),
  })

export default schemaUser
